module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/equipment04-3cf57e056c3681dd306a65c1a0daf00d.png";